import { jsx as _jsx } from "react/jsx-runtime";
import { shortcutLabel } from './runtime.js';
/**
 * Small key chip for a catalogue id. Decorative (aria-hidden: the control carries
 * `aria-keyshortcuts`) and hidden on touch devices, where there is no keyboard to hint at.
 */
export function Kbd({ id, className }) {
    const label = shortcutLabel(id);
    if (!label)
        return null;
    return (_jsx("kbd", { className: `vk-kbd${className ? ` ${className}` : ''}`, "aria-hidden": "true", children: label }));
}
//# sourceMappingURL=Kbd.js.map